import {
  BrowserFamily,
  BrowserSupportPolicy,
} from "@shared/utils/browserDetection";

export const MODERN_BROWSER_POLICY: BrowserSupportPolicy = {
  allowedFamilies: ["chrome", "edge", "firefox"],
  policyVersion: "browser-policy-v3-2026-05-15",
  minimumVersions: {
    chrome: 142,
    edge: 142,
    firefox: 146,
  },
  warningVersions: {
    chrome: 146,
    edge: 146,
    firefox: 150,
  },
  enforcementDates: {
    chrome: "2026-06-30",
    edge: "2026-06-30",
    firefox: "2026-06-30",
  },
  overrideTtlMinutes: 8 * 60,
};

export const BROWSER_RELEASE_NOTES: Partial<Record<BrowserFamily, string>> = {
  chrome: "https://chromereleases.googleblog.com/",
  edge: "https://learn.microsoft.com/deployedge/microsoft-edge-relnote-stable-channel",
  firefox: "https://www.mozilla.org/firefox/releases/",
};

export const BROWSER_SUPPORT_UPDATED_AT = "2026-04-12";
